import { Button, DatePicker } from "antd";
import styles from "../styles/Content.module.css";
import { ReactComponent as UserLocked } from "../../../assets/icons/user-locked.svg";
import { ReactComponent as UserTag } from "../../../assets/icons/user-tag.svg";
import { ReactComponent as Buffalo } from "../../../assets/icons/buffalo.svg";
import { ReactComponent as ArrowUp } from "../../../assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrow-down.svg";
import { UnorderedListOutlined } from "@ant-design/icons";

const CustomerTracking = ({ summaryClients, handleRangesDates, goToClients }) => {
  return (
    <div className={styles.cardContent}>
      <div className={styles.itemDatePicker}>
        <DatePicker.RangePicker
          onChange={handleRangesDates}
          style={{ borderRadius: '8px' }}
        />
      </div>

      <div className={styles.totalOverview}>
        <div className={styles.antCard}>
          <div style={{ padding: '24px 16px' }}>
            <div className={styles.customerIcon}>
              <UserLocked />
            </div>
            <p className={styles.number}>2,266</p>
            <p className={styles.label}>Usuarios Registrados</p>
          </div>
        </div>
        <div className={styles.antCard}>
          <div style={{ padding: '24px 16px' }}>
            <div className={styles.customerIcon}>
              <UserTag />
            </div>
            <p className={styles.number}>1,035</p>
            <p className={styles.label}>Usuarios Activos</p>
          </div>
        </div>
        <div className={styles.antCard}>
          <div style={{ padding: '24px 16px' }}>
            <div className={styles.customerIcon}>
              <Buffalo />
            </div>
            <p className={styles.number}>1,582</p>
            <p className={styles.label}>Órdenes Realizadas</p>
          </div>
        </div>
      </div>

      <div className={styles.containerIndicators}>
        <div className={styles.indicatorCard}>
          <span className={styles.amountPercent}>
            <p className={styles.amount}>11</p>
            <ArrowUp />
            <p className={styles.percentSuccess}>76%</p>
          </span>
          <p className={styles.indicator}>Clientes Nuevos</p>
          <Button
            type="default"
            className={styles.buttonListClient}
            onClick={goToClients}
            icon={<UnorderedListOutlined />}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            Listado
          </Button>
        </div>

        <div className={styles.indicatorCard}>
          <span className={styles.amountPercent}>
            <p className={styles.amount}>5</p>
            <ArrowDown />
            <p className={styles.percentFail}>8%</p>
          </span>
          <p className={styles.indicator}>Segundo Pedido</p>
          <Button
            type="default"
            className={styles.buttonListClient}
            onClick={goToClients}
            icon={<UnorderedListOutlined />}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            Listado
          </Button>
        </div>

        <div className={styles.indicatorCard}>
          <span className={styles.amountPercent}>
            <p className={styles.amount}>3</p>
            <ArrowDown />
            <p className={styles.percentFail}>12%</p>
          </span>
          <p className={styles.indicator}>Tercer Pedido</p>
          <Button
            type="default"
            className={styles.buttonListClient}
            onClick={goToClients}
            icon={<UnorderedListOutlined />}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            Listado
          </Button>
        </div>

        <div className={styles.indicatorCard}>
          <span className={styles.amountPercent}>
            <p className={styles.amount}>2</p>
            <ArrowDown />
            <p className={styles.percentFail}>18%</p>
          </span>
          <p className={styles.indicator}>Cuarto Pedido</p>
          <Button
            type="default"
            className={styles.buttonListClient}
            onClick={goToClients}
            icon={<UnorderedListOutlined />}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            Listado
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomerTracking;
